export default __webpack_public_path__ + "static/media/sliderWithButton.56d21f53.png";